import React, { useEffect, useRef } from "react";
import './../style/privacy.css';

function Privacy() {

    return (
        <div id="privacy">
            <div className="top-spacing"/>

            <div className="main">

            <section>
                <h1>Polityka prywatności aplikacji QuickExpense</h1>
                <p>Aplikacja QuickExpense umożliwia użytkownikowi rejestrowanie dokumentów kosztowych, wykonywanie zdjęć dokumentów oraz automatyczne uzupełnianie części danych na podstawie analizy obrazu.</p>

                <h2>1. Jakie dane przetwarza aplikacja</h2>
                <p>Aplikacja może uzyskiwać dostęp do:</p>
                <ul>
                    <li>aparatu urządzenia, w celu wykonania zdjęcia dokumentu,</li>
                    <li>zdjęć wybranych przez użytkownika,</li>
                    <li>danych wpisywanych ręcznie przez użytkownika, takich jak kwoty, daty, numery dokumentów, nazwy kontrahentów i notatki.</li>
                </ul>

                <h2>2. Gdzie przechowywane są dane</h2>
                <p>Dane i zdjęcia dokumentów są przechowywane lokalnie na urządzeniu użytkownika. Aplikacja nie wysyła tych danych na własny serwer dewelopera, o ile użytkownik sam nie skorzysta z funkcji eksportu lub udostępniania.</p>

                <h2>3. OCR i skanowanie dokumentów</h2>
                <p>Aplikacja korzysta z bibliotek Google ML Kit oraz komponentów Google Play services w celu skanowania dokumentów i rozpoznawania tekstu, aby ułatwić automatyczne wypełnianie danych z paragonów i faktur.</p>

                <h2>4. Udostępnianie danych</h2>
                <p>Aplikacja nie sprzedaje danych użytkownika i nie udostępnia ich podmiotom trzecim w celach marketingowych. Dane mogą być przekazywane wyłącznie wtedy, gdy użytkownik sam uruchomi funkcję eksportu, wysyłki lub udostępnienia dokumentów.</p>

                <h2>5. Uprawnienia</h2>
                <p>Aplikacja może prosić o dostęp do aparatu w celu wykonywania zdjęć dokumentów. Uprawnienie to jest wykorzystywane wyłącznie do funkcji dostępnych w aplikacji.</p>

                <h2>6. Kontakt</h2>
                <p>W sprawach dotyczących prywatności można skontaktować się pod adresem:</p>
                <p><strong>biuro@habp.pl</strong></p>
            </section>



            <section lang="en">
                <h1>Privacy Policy for QuickExpense</h1>
                <p>QuickExpense allows users to register expense documents, capture photos of documents, and automatically fill selected fields based on image analysis.</p>

                <h2>1. What data the app processes</h2>
                <p>The app may access:</p>
                <ul>
                    <li>the device camera, to capture document photos,</li>
                    <li>photos selected by the user,</li>
                    <li>information manually entered by the user, such as amounts, dates, document numbers, contractor names, and notes.</li>
                </ul>

                <h2>2. Where data is stored</h2>
                <p>Data and document photos are stored locally on the user’s device. The app does not send this data to the developer’s own servers unless the user explicitly uses an export, sharing, or sending feature.</p>

                <h2>3. OCR and document scanning</h2>
                <p>The app uses Google ML Kit libraries and Google Play services components for document scanning and text recognition in order to help automatically fill in data from receipts and invoices.</p>

                <h2>4. Data sharing</h2>
                <p>The app does not sell user data and does not share it with third parties for marketing purposes. Data may only be transferred when the user explicitly chooses to export, send, or share documents.</p>

                <h2>5. Permissions</h2>
                <p>The app may request access to the camera in order to capture document images. This permission is used only for features available in the app.</p>

                <h2>6. Contact</h2>
                <p>For privacy-related questions, contact:</p>
                <p><strong>biuro@habp.pl</strong></p>
            </section>

            </div>
        </div>
    )
}

export default Privacy;
